import { BaseAPI } from 'API/BaseApi';

/**
 * Document Package Timber API
 */
export const DocumentPackageApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    generatePackage: build.mutation<any, { orderId: string; packageType: string }>({
      query: ({ orderId, packageType }) => ({
        url: `/timber/api/internal/orders/${orderId}/document-packages/${packageType}`,
        method: 'POST',
      }),
      // invalidatesTags: (response, error, { orderId }) => [{ type: eAPITags.TODO, id: orderId }],
    }),
  }),
});

export const { useGeneratePackageMutation } = DocumentPackageApi;
